module.exports = __webpack_public_path__ + "static/media/STAF_nynorsk_sekundærlogo_pos(svart).0c1b2ab8.png";